// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__R+5hz","content":"main_content__pzt9i"};